/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { isEmpty } from '@ember/utils';
import SidebarService from 'cio/services/sidebar';

interface Args {
  highlight: boolean;
  highlightColor?: string;
  name: string;
  icon: string;
  cta: string;
  selected: boolean;
  toggleSidebar: () => unknown;
  handleSidebarClose: () => unknown;
  sidebar: SidebarService;
  type?: string;
  disabled: boolean;
  disabledTooltip?: string;
}

export default class ConditionBlockItemBlock extends Component<Args> {
  get showDisabledTooltip() {
    return this.args.disabled === true && !isEmpty(this.args.disabledTooltip);
  }
}
